"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.findOne = findOne;
exports.getInfo = getInfo;
exports.getList = getList;
exports.login = login;
exports.logout = logout;
exports.reset = reset;
exports.update = update;
exports.updatePassword = updatePassword;
exports.updateProfile = updateProfile;
var _request = _interopRequireDefault(require("@/utils/request"));
function login(data) {
  return (0, _request.default)({
    url: "/auth/login",
    method: "post",
    data: data
  });
}
function getInfo() {
  return (0, _request.default)({
    url: "/auth/profile",
    method: "get"
  });
}
function updateProfile(data) {
  return (0, _request.default)({
    url: "/auth/profile",
    method: "post",
    data: data
  });
}
function reset(id, data) {
  return (0, _request.default)({
    url: "/users/".concat(id, "/resetPassword"),
    method: "post",
    data: data
  });
}
function findOne(userId) {
  return (0, _request.default)({
    url: "/users/".concat(userId),
    method: "get"
  });
}
function updatePassword(data) {
  return (0, _request.default)({
    url: "/auth/password/update",
    method: "post",
    data: data
  });
}
function getList(listQuery) {
  return (0, _request.default)({
    url: "/users",
    method: "get",
    params: listQuery
  });
}
function add(data) {
  return (0, _request.default)({
    url: "/users",
    method: "post",
    data: data
  });
}
function update(userId, data) {
  return (0, _request.default)({
    url: "/users/".concat(userId, "/update"),
    method: "post",
    data: data
  });
}
function logout() {
  return (0, _request.default)({
    url: "/user/logout",
    method: "post"
  });
}